module.exports = __webpack_public_path__ + "img/jobsmedia-logo.9ba60020.svg";